import {
   Api,
   decryptApiResponse,
} from '../../../config/Api';
import { statusAndResponse } from '../../../util/requestHandler';

export function fetchChangeStatus(recordId, statusUser) {
   console.log(recordId, statusUser);
   return statusAndResponse(
      Api.post(`/api/v2/users/change/status`, { "userId": recordId, "status": `${statusUser}` },
         decryptApiResponse)
   );
}
